// extracted by mini-css-extract-plugin
export var attachment = "_pe-a";
export var emailContainer = "_pe-4";
export var emailContentPaddedContainer = "_pe-b";
export var emailHeader = "_pe-6";
export var emailIframe = "_pe-3";
export var emailInfoIcon = "_pe-9";
export var emailShortenedSummary = "_pe-e";
export var infoDropdown = "_pe-0";
export var infoRowBoundedContent = "_pe-d";
export var internal = "_pe-5";
export var merchant = "_pe-8";
export var messageInputContainer = "_pe-h";
export var normal = "_pe-7";
export var replyCard = "_pe-f";
export var subtleButton = "_pe-1";
export var subtleButtonIconContainer = "_pe-2";
export var toggleViewRepliesButton = "_pe-c";
export var wrappingText = "_pe-g";